import { Injectable } from '@angular/core';

import { CmsComponentConfig } from '@interfaces/config';
import { CmsComponentNodeData, CmsFixes } from '@models/interfaces';
import { ParagraphTextMarginalData } from '@generated/content';
import { TextMarginal } from '@interfaces/config/cms-components/text-marginal-config';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { CardComponentResolver } from '@services/resolvers/component-resolvers/card-component/card-component-resolver';

@Injectable({ providedIn: 'root' })
export class TextMarginalComponentResolver extends BaseComponentResolver {
  static override instance: TextMarginalComponentResolver;
  private readonly componentType = TextMarginal.TypeEnum;

  static getInstance(): TextMarginalComponentResolver {
    return (TextMarginalComponentResolver.instance ||= new TextMarginalComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphTextMarginalData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<TextMarginal.ComponentConfig> | null {
    this.nodePageData = nodePageData;

    const headline = this.hyphenate(node.attributes.field_title_textmarginal);
    const html = this.hyphenate((node.attributes.field_description_textmarginal as CmsFixes.CmsFreetextObject)?.processed);

    const config: TextMarginal.ComponentConfig = {
      nodeId: BaseComponentResolver.getNodeId(node),
      headline,
      html,
      card: CardComponentResolver.getCardConfig(node.relationships.field_document_textmarginal, nodePageData),
    };

    return { componentType: this.componentType, config };
  }
}
